import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M9.00057 3.99951V1.99951H7.00057V3.99951H5.43437L1.23438 10.9995H22.7668L18.5668 3.99951H9.00057Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M21 12.9995H3V21.9995H8.50098V16H15.501V21.9995H21V12.9995Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M10.501 18V22H13.501V18H10.501Z"}}]};

const Houses2Filled = Vue.extend<IconProps>({
  name: 'Houses2FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'houses-2-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Houses2Filled;
